import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Toolstack from "./Toolstack";

// ✅ Import SocialPopup
import SocialPopup from "../Home/SocialPopup";

function About() {
  return (
    <Container fluid className="about-section" id="skills">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>
        <hr style={{ borderTop: "2px solid #ccc", margin: "20px 0" }} />

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <Github />

        {/* CTA Section */}
        <div className="about-cta-section">
          <div className="cta-content">
            <h3>Ready to start your project?</h3>
            <p>Let's discuss how I can help you build faster, smarter, and better.</p>
            <div className="cta-buttons">
              <a href="#contacts" className="cta-primary">Get in Touch</a>
              <a href="#projects" className="cta-secondary">View Projects</a>
            </div>
          </div>
        </div>

        {/* ✅ Add SocialPopup component at the bottom (or wherever you want) */}
        <div style={{ marginTop: "40px" }}>
          <SocialPopup />
        </div>

        <style>{`
          .about-cta-section {
            margin-top: 60px;
            padding: 50px 30px;
            background: linear-gradient(135deg, rgba(0,198,255,0.08), rgba(0,114,255,0.08));
            border-radius: 24px;
            border: 1px solid rgba(0,198,255,0.15);
            text-align: center;
          }
          
          .cta-content h3 {
            color: white;
            font-family: 'Syne', sans-serif;
            font-size: 1.8rem;
            margin-bottom: 12px;
          }
          
          .cta-content p {
            color: rgba(200,210,255,0.7);
            margin-bottom: 24px;
            font-size: 1.05rem;
          }
          
          .cta-buttons {
            display: flex;
            gap: 16px;
            justify-content: center;
            flex-wrap: wrap;
          }
          
          .cta-primary {
            padding: 12px 30px;
            background: linear-gradient(90deg, #00c6ff, #0072ff);
            color: white;
            text-decoration: none;
            border-radius: 50px;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 6px 20px rgba(0,114,255,0.3);
          }
          
          .cta-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 28px rgba(0,114,255,0.4);
            color: white;
            text-decoration: none;
          }
          
          .cta-secondary {
            padding: 12px 30px;
            background: transparent;
            color: white;
            text-decoration: none;
            border-radius: 50px;
            font-weight: 600;
            border: 1px solid rgba(255,255,255,0.2);
            transition: all 0.3s ease;
          }
          
          .cta-secondary:hover {
            border-color: #00c6ff;
            color: #00c6ff;
            text-decoration: none;
          }
        `}</style>
      </Container>
    </Container>
  );
}

export default About;
